import {connect} from 'react-redux';
import Search from '../../components/search/search';

const mapStateToProps = (state) => {
  return {
    entity: state.store.entity,
    config: state.store.config,
  };
};

export default connect(mapStateToProps)(Search);



// WEBPACK FOOTER //
// ./src/containers/searchpage/index.js